import {
  IActiveSessionDevice,
  IDemoAccountCreation,
  IDemoAccountCreationV1Params,
  IDemoSignUpParams,
  ILogoutDevicesParams,
  ISwitchMetatraderAccount,
  ISwitchMetatraderAccountParams,
  IUserDetail
} from '@aqx-core/common/api/user-account';
import { request } from '@aqx-core/common/request';

export default {
  getAccounts: () => request.get<IUserDetail>('/api/user/account/v1'),
  switchMetatraderAccount: (params: ISwitchMetatraderAccountParams) =>
    request.patch<ISwitchMetatraderAccount>('/api/user/v1/account', params),
  createDemoAccountWithoutLogin: (params: IDemoAccountCreationV1Params) =>
    request.post<IDemoAccountCreation>('/api/user/account/v1/demo', params),
  createDemoAccountWithLogin: (params: IDemoAccountCreationV1Params) =>
    request.post<IDemoAccountCreation>('/api/user/account/v1/demo/auth', params),
  getActiveSessionDevices: () => request.get<IActiveSessionDevice[]>('/api/user/account/v1/devices'),
  logoutDevices: (params: ILogoutDevicesParams) => request.post<boolean>('/api/user/account/v1/devices/logout', params),
  demoSignUp: (params: IDemoSignUpParams) => request.post<IDemoAccountCreation>('/api/user/v3/account/demo', params),
  demoSignUpAuthenticated: (params: IDemoSignUpParams) =>
    request.post<IDemoAccountCreation>('/api/user/v3/account/demo/auth', params)
};
